<template>
    <div>
       
        <PreventiveSportsSplints />
    </div>
</template>

<script>

import PreventiveSportsSplints from '../../components/blog-details/PreventiveSportsSplints'

export default {
    components: {
       
        PreventiveSportsSplints,
    }
}
</script>